module.exports = __webpack_public_path__ + "img/h_diamonds.5c27d80d.png";